import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const HelpCenterSettingsArticlesAppEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-help-center-setting-articles-app" */ './src/ui'),
	),
	getPreloadProps: () => {
		return {};
	},
});
